import { EquipAffix } from "../equipmentType";
import { entryPool, entryDeBuffPool } from "./entries";
// 后缀池
const sufPool = {
  玄武: {
    affName: "玄武",
    affProps: [entryPool.VITV2]
  },
  朱雀: {
    affName: "朱雀",
    affProps: [entryPool.HPV2]
  },
  白虎: {
    affName: "白虎",
    affProps: [entryPool.ATKV2]
  },
  青龙: {
    affName: "青龙",
    affProps: [entryPool.DEXV2]
  },
  咆哮: {
    affName: "咆哮",
    affProps: [entryPool.ATKV, entryPool.DEFV]
  },
  战神: {
    affName: "战神",
    affProps: [entryPool.STRV, entryPool.VITV]
  },
  疾风: {
    affName: "疾风",
    affProps: [entryPool.DEXV, entryPool.ASV]
  },
  赌怪: {
    affName: "赌怪",
    affProps: [entryPool.CRDV3]
  },
  如山: {
    affName: "如山",
    affProps: [entryPool.DEFV2, entryPool.VITV]
  },
  神工: {
    affName: "神工",
    affProps: [entryPool.ATKV, entryPool.VITV]
  },
  神射手: {
    affName: "神射",
    affProps: [entryPool.CRRV2, entryPool.ASV, entryDeBuffPool.DCRDV]
  }
};
const sufPoolList: EquipAffix[] = Object.values(sufPool);
export { sufPool, sufPoolList };
